module.exports = __webpack_public_path__ + "img/slide1.834f2114.png";